"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenGraph = exports.appWithOpenGraph = exports.getOpenGraphProp = exports.createOpenGraphProp = exports.OpenGraphAutoConsume = exports.OpenGraph = exports.OPEN_GRAPH_PROP = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const isNil_1 = __importDefault(require("lodash/fp/isNil"));
const omitBy_1 = __importDefault(require("lodash/fp/omitBy"));
const head_1 = __importDefault(require("next/head"));
const react_1 = __importStar(require("react"));
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const fdr_lib_context_lang_1 = require("@hotelplan/fdr.lib.context.lang");
const fdr_lib_i18n_lang_page_props_1 = require("@hotelplan/fdr.lib.i18n.lang-page-props");
exports.OPEN_GRAPH_PROP = '__og';
function OpenGraph(props) {
    const { url, image, title, description, locale } = props;
    if ([url, image, title, description].filter(Boolean).length === 0)
        return null;
    return (react_1.default.createElement(head_1.default, null,
        locale && react_1.default.createElement("meta", { key: "og:locale", property: "og:locale", content: locale }),
        url && react_1.default.createElement("meta", { key: "og:url", property: "og:url", content: url }),
        title && react_1.default.createElement("meta", { key: "og:title", property: "og:title", content: title }),
        description && (react_1.default.createElement("meta", { key: "og:des", property: "og:description", content: description })),
        image && react_1.default.createElement("meta", { key: "og:image", property: "og:image", content: image })));
}
exports.OpenGraph = OpenGraph;
function OpenGraphAutoConsume() {
    const ctx = useOpenGraph();
    return react_1.default.createElement(OpenGraph, Object.assign({}, ctx));
}
exports.OpenGraphAutoConsume = OpenGraphAutoConsume;
function createOpenGraphProp({ title, url, image, description, }) {
    return {
        [exports.OPEN_GRAPH_PROP]: [title, url, image, description].map(v => v || 0),
    };
}
exports.createOpenGraphProp = createOpenGraphProp;
function getOpenGraphProp(pageProps) {
    var _a;
    const prop = ((_a = pageProps === null || pageProps === void 0 ? void 0 : pageProps.pageProps) === null || _a === void 0 ? void 0 : _a[exports.OPEN_GRAPH_PROP]) || (pageProps === null || pageProps === void 0 ? void 0 : pageProps[exports.OPEN_GRAPH_PROP]);
    if (!prop)
        return;
    const [title, url, image, description] = prop.map(v => v || undefined);
    return (0, omitBy_1.default)(isNil_1.default)({ title, url, image, description });
}
exports.getOpenGraphProp = getOpenGraphProp;
const OpenGraphContext = react_1.default.createContext({});
function appWithOpenGraph({ enable, openGraphLocale = locale => `${locale}_CH`, fallback, }) {
    return function (AppComponent) {
        if (!enable)
            return AppComponent;
        function AppWithOpenGraph(props) {
            const { canonical } = (0, fdr_lib_context_lang_1.useLanguages)();
            const value = (0, react_1.useMemo)(() => {
                var _a, _b;
                const { locale } = (0, libs_router_config_1.getRoutePageProp)(props.pageProps);
                const { title: fallbackTitle, image: fallbackImage } = fallback(locale, props.pageProps);
                const { title = fallbackTitle, description } = ((_a = props.pageProps) === null || _a === void 0 ? void 0 : _a['meta']) || {};
                const canonicalUrls = (0, fdr_lib_i18n_lang_page_props_1.getCanonicalLanguages)(props.pageProps);
                const ogLocale = openGraphLocale(locale, props.pageProps);
                return Object.assign({ title,
                    description, locale: ogLocale, image: fallbackImage, 
                    // language urls context might be missing, trying to find properties data
                    url: canonical || ((_b = canonicalUrls === null || canonicalUrls === void 0 ? void 0 : canonicalUrls[locale]) === null || _b === void 0 ? void 0 : _b.uri) }, getOpenGraphProp(props.pageProps));
            }, [canonical, props.pageProps]);
            return (react_1.default.createElement(OpenGraphContext.Provider, { value: value },
                react_1.default.createElement(AppComponent, Object.assign({}, props))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithOpenGraph, AppComponent);
    };
}
exports.appWithOpenGraph = appWithOpenGraph;
function useOpenGraph() {
    return (0, react_1.useContext)(OpenGraphContext);
}
exports.useOpenGraph = useOpenGraph;
//# sourceMappingURL=index.js.map